import angular from 'angular';

export class StopReasonModalController {
  /* @ngInject */
  constructor(stopReasons, close) {
    this.stopReasons = stopReasons;
    this.close = close;
  }

  save() {
    this.close(this.stopReason);
  }
}

export default angular.module('app.components.campaigns.stopReasonModal', [])
  .controller('StopReasonModalController', StopReasonModalController);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/stopReasonModal.js
 **/